export default __webpack_public_path__ + "static/media/proride-kids-2.7d448e66.webp";